import { render, staticRenderFns } from "./editPerformanceType.vue?vue&type=template&id=78025189&"
import script from "./editPerformanceType.vue?vue&type=script&lang=js&"
export * from "./editPerformanceType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports